// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1ytDB","checkboxCol":"Table_checkboxCol__1ZqoL","emailCol":"Table_emailCol__k9S5I","actionCol":"Table_actionCol__1Oa49"};